import React from 'react'
import PropTypes from 'prop-types'

export const ReportItemStatusBadge = ({
  displayName,
  color
}) => {
  if (!displayName) return '--'

  return (
    <div className='radius-md relative flex font-size-xs gap-2 items-center'>
      <div className='radius-round' style={{ backgroundColor: color ?? '#333', height: '1em', width: '1em' }} />
      <div>{displayName}</div>
    </div>
  )
}

ReportItemStatusBadge.propTypes = {
  displayName: PropTypes.string,
  color: PropTypes.string
}

export default ReportItemStatusBadge
